import { getWixSDK } from '../utils/wix-sdk';
import { attempt } from '../utils/attempt';

export function getVisitorId() {
  const WixSDK = getWixSDK();
  return (
    attempt(() => WixSDK.Utils.getInstanceValue('uid')) ||
    attempt(() => WixSDK.Utils.getInstanceValue('aid')) ||
    ''
  );
}
